<ng-container *ngIf="report; else elseTemplate">
  <div class="row">
    <div class="col-12 col-md-9 col-lg-9">
      <div class="summary-triplet">
        <div class="summary-wrapper">
          <div class="summary-label" i18n="report-summay|@@matriculation">Immatriculation</div>
          <div class="summary-value">{{report?.tchekPtr?.vehiclePtr?.immat | uppercase }}</div>
        </div>
        <div class="summary-wrapper"
          *ngIf="settings && settings.vehicle && settings.vehicle.orNumber && report?.tchekPtr?.vehiclePtr?.or">
          <div class="summary-label" i18n="report-summay|@@repair_number">O.R.</div>
          <div class="summary-value">{{report?.tchekPtr?.vehiclePtr?.or}}</div>
        </div>
        <div class="summary-wrapper"
          *ngIf="settings && settings.vehicle && settings.vehicle.vinNumber && report?.tchekPtr?.vehiclePtr?.vin">
          <div class="summary-label">V.I.N.</div>
          <div class="summary-value">{{report?.tchekPtr?.vehiclePtr?.vin}}</div>
        </div>
        <div class="summary-wrapper d-none d-xl-block" *ngIf="showSignatory">
          <p class="summary-label" i18n="report-summay|@@signatory">Signataire</p>
          <p class="summary-value">{{signatoryFullName()}}</p>
        </div>
        <div class="summary-wrapper d-none d-md-block">
          <p class="summary-label" i18n="report-summay|@@operator">Opérateur</p>
          <p class="summary-value">{{operatorFullName()}}</p>
        </div>
        <div class="summary-wrapper">
          <p class="summary-label">Type</p>
          <p class="summary-value">{{reportValue()}} <app-edit-value-modal [type]="'select'"
              [possibleValuesSelect]="typeReportOptionsSelect" [initialValue]="report?.typeReport"
              (newValue)="handleTypeReportValue($event)"></app-edit-value-modal>
        </div>
        <div class="summary-wrapper">
          <p class="summary-label">Sens</p>
          <p class="summary-value">{{report?.contractWayFormatted}} <app-edit-value-modal [type]="'select'"
              [possibleValuesSelect]="wayOptionsSelect" [initialValue]="report?.contractWay"
              (newValue)="handleContractWayValue($event)"></app-edit-value-modal>
          </p>
        </div>
        <div class="summary-wrapper d-none d-lg-block">
          <p class="summary-label" i18n="report-summay|@@scanner">Scanner</p>
          <p class="summary-value">{{report?.tchekPtr?.devicePtr?.serialNumber}}</p>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-3 col-lg-3">
      <div class="summary-actions">
        <button *ngIf="ctaAction==='checksi'" class="btn btn-lg primary import" (click)="handleSendToVPA()"
          i18n="report-summay|@@send_to_si">Envoyer
          vers SI</button>

        <button *ngIf="ctaAction==='exportexcel'" class="btn btn-lg primary import" (click)="handleSendToVPA()"
          i18n="report-summay|@@export_to_exel">Export vers
          Excel</button>
        <button *ngIf="ctaAction==='sendmail'" [ngClass]="{'disabled': isBuildingPdf || !reportId}"
          class="btn btn-lg primary import" (click)="handleSendPdf()">
          <span *ngIf="!isBuildingPdf; else buildProgressBar" i18n="report-summay|@@send_pdf">Envoyer le PDF</span>
          <ng-template #buildProgressBar>
            <div class="progress">
              <div class="progress-bar" role="progressbar" [ngStyle]="{'width.%': reportBuildProgress}"
                aria-valuemin="0" aria-valuemax="100"></div>
            </div>
          </ng-template>
        </button>
        <button *ngIf="ctaAction==='openpdf'" [ngClass]="{'disabled': isBuildingPdf || !reportId}"
          class="btn btn-lg primary import" (click)="handleSendPdf()">
          <span *ngIf="!isBuildingPdf; else buildProgressBar" i18n="report-summay|@@send_pdf">Ouvrir le PDF</span>
          <ng-template #buildProgressBar>
            <div class="progress">
              <div class="progress-bar" role="progressbar" [ngStyle]="{'width.%': reportBuildProgress}"
                aria-valuemin="0" aria-valuemax="100"></div>
            </div>
          </ng-template>
        </button>
        <app-submenu [options]="submenuOptions" (selectedOption)="handleSubmenuSelection($event)">
          <button class="btn btn-lg secondary"><svg width="4px" height="16px" viewBox="0 0 4 16" version="1.1"
              xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <title>Plus...</title>
              <desc>Created with Sketch.</desc>
              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="UI-Rapport" transform="translate(-1231.000000, -191.000000)" fill="#162C4B" fill-rule="nonzero">
                  <g id="Header-Small" transform="translate(165.000000, 153.000000)">
                    <g id="CTA" transform="translate(1050.000000, 23.000000)">
                      <g id="menu-dots"
                        transform="translate(18.000000, 23.000000) rotate(90.000000) translate(-18.000000, -23.000000) translate(10.000000, 21.000000)">
                        <circle id="Oval" cx="8" cy="2" r="2"></circle>
                        <circle id="Oval" cx="2" cy="2" r="2"></circle>
                        <circle id="Oval" cx="14" cy="2" r="2"></circle>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </svg></button>
        </app-submenu>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #elseTemplate>
  <div class="row">
    <div class="col-2">
      <content-loader [width]="125" [height]="25">
        <svg:rect id="rect3686" width="100%" height="20" x="0" y="0" rx="3" ry="3"
          style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
      </content-loader>
      <content-loader [width]="125" [height]="20">
        <svg:rect id="rect3686" width="100%" height="100%" x="0" y="0" rx="3" ry="3"
          style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
      </content-loader>
    </div>
    <div class="col-2">
      <content-loader [width]="125" [height]="25">
        <svg:rect id="rect3686" width="100%" height="20" x="0" y="0" rx="3" ry="3"
          style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
      </content-loader>
      <content-loader [width]="125" [height]="20">
        <svg:rect id="rect3686" width="100%" height="100%" x="0" y="0" rx="3" ry="3"
          style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
      </content-loader>
    </div>
    <div class="col-2">
      <content-loader [width]="125" [height]="25">
        <svg:rect id="rect3686" width="100%" height="20" x="0" y="0" rx="3" ry="3"
          style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
      </content-loader>
      <content-loader [width]="125" [height]="20">
        <svg:rect id="rect3686" width="100%" height="100%" x="0" y="0" rx="3" ry="3"
          style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
      </content-loader>
    </div>
    <div class="col-2">
      <content-loader [width]="125" [height]="25">
        <svg:rect id="rect3686" width="100%" height="20" x="0" y="0" rx="3" ry="3"
          style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
      </content-loader>
      <content-loader [width]="125" [height]="20">
        <svg:rect id="rect3686" width="100%" height="100%" x="0" y="0" rx="3" ry="3"
          style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
      </content-loader>
    </div>
    <div class="col-2">
      <content-loader [width]="125" [height]="25">
        <svg:rect id="rect3686" width="100%" height="20" x="0" y="0" rx="3" ry="3"
          style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
      </content-loader>
      <content-loader [width]="125" [height]="20">
        <svg:rect id="rect3686" width="100%" height="100%" x="0" y="0" rx="3" ry="3"
          style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
      </content-loader>
    </div>
    <div class="col-2">
      <content-loader [width]="125" [height]="25">
        <svg:rect id="rect3686" width="100%" height="20" x="0" y="0" rx="3" ry="3"
          style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
      </content-loader>
      <content-loader [width]="125" [height]="20">
        <svg:rect id="rect3686" width="100%" height="100%" x="0" y="0" rx="3" ry="3"
          style="fill:#f9f9f9;fill-opacity:0.97894736;stroke:none;stroke-width:0.26458332;stroke-opacity:1" />
      </content-loader>
    </div>
  </div>
</ng-template>


// WEBPACK FOOTER //
// ./src/app/element/report-summary/report-summary.component.html